import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=2326f158&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=2326f158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2326f158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2326f158')) {
      api.createRecord('2326f158', component.options)
    } else {
      api.reload('2326f158', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=2326f158&scoped=true&", function () {
      api.rerender('2326f158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/會員相關/Detail.vue"
export default component.exports